var DTI_CALC = 'dti_calc';
var TOOLTIP = 'tooltip';
var MODAL_DIALOG = 'modal_dialog';

export { DTI_CALC, MODAL_DIALOG, TOOLTIP };
